import { useAuthUser } from "../../../stores/authStore";
import { useIdentidade } from "../../conta/api";
import { useCapacidades } from "./api";

/**
 * Se quem está logado pode abrir chamado: a escrita ligada no ambiente e, para a equipe T4i, a
 * função de abrir chamado em nome do cliente. A lista e o Kanban mostram o botão pela mesma regra
 * (06/10/2026).
 */
export function usePodeAbrirChamado(): boolean {
  const usuario = useAuthUser();
  const { data: capacidades } = useCapacidades();
  const { data: identidade } = useIdentidade(Boolean(usuario));
  const equipe = Boolean(usuario?.equipe);
  return Boolean(capacidades?.escritasHabilitadas) && (!equipe || Boolean(identidade?.abreChamados));
}
